import { render, staticRenderFns } from "./DemergeAction.vue?vue&type=template&id=b92814a6&"
import script from "./DemergeAction.vue?vue&type=script&lang=js&"
export * from "./DemergeAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports